/**
 * Controller
 *
 * @class
 */
class Controller {
	/**
	 * @constructor
	 */
	constructor() {
		this._controllers = [];
	}

	// Public

	/**
	 * Initialize
	 *
	 * @return void
	 */
	initialize() {
		this._forEachCallFunction('onReady');
	}

	/**
	 * On Load
	 *
	 * @return void
	 */
	onLoad() {
		this._forEachCallFunction('onLoad');
	}

	/**
	 * Registers a controller from an extension
	 *
	 * @param { AbstractController } controller
	 * @return void
	 */
	registerController(controller) {
		this._controllers.push(controller);
	}

	// Private

	/**
	 * Calls a function for every controller
	 *
	 * @param { String } fnName Name of function to be called
	 * @param { Object } args Potential arguments for fnName
	 * @return void
	 */
	_forEachCallFunction(fnName, args = {}) {
		this._controllers.forEach((controller) => {
			if (typeof controller[fnName] === 'function') {
				controller[fnName].call(controller, ...args);
			}
		});
	}
}

export default (new Controller);
